import { User } from "../../models/User";

abstract class IAuthRepository {
    abstract login: () => Promise<User | undefined>;
    abstract logout: () => Promise<void>;
    abstract getCurrentUser: () => Promise<User|undefined>;
}

export default IAuthRepository;